import { getVideoFrames, GetVideoFramesOptions, VideoFrames } from 'utils/getVideoFrames';
import { Transition, TransitionType } from 'types/Transitions';

const THRESHOLD = 90;
const MAX_TRANSITIONS = 20;

const videos: { [key: string]: VideoFrames } = {};

const canvas = document.createElement('canvas');
canvas.height = 0;
canvas.width = 0;

const ctx = canvas.getContext('2d');

const processFrame: GetVideoFramesOptions['processFrame'] = imageData => {
  for (let i = 0; i < imageData.data.length; i += 4) {
    const r = imageData.data[i];
    const g = imageData.data[i + 1];
    const b = imageData.data[i + 2];

    if (r < THRESHOLD && g < THRESHOLD && b < THRESHOLD) {
      imageData.data[i + 3] = 0;
    }
  }

  return imageData;
};

export const updateTransitionList = async (transitions: Transition[]) => {
  const filteredTransitions = transitions.reduce((acc, curr) => {
    if (curr.type !== TransitionType.Shape) return acc;
    if (acc.some(({ id }) => curr.id === id)) return acc;

    acc.push(curr);
    return acc;
  }, []);

  await Promise.all(
    filteredTransitions
      .filter(({ id }) => !(id in videos))
      .map(async ({ preview_url, id }) => {
        videos[id] = await getVideoFrames({ src: preview_url, processFrame });
      })
  );

  if (Object.keys(videos).length > MAX_TRANSITIONS) {
    const idList = filteredTransitions.map(item => item.id);
    for (const key in videos) {
      if (!idList.some(id => id === key)) {
        delete videos[key];
      }
    }
  }
};

export const getFrame = (
  transition: Transition,
  time: number
): [HTMLCanvasElement, number, number] => {
  const { width, height, getFrameByTime } = videos[transition.id];
  const frame = getFrameByTime(time);

  canvas.width = width;
  canvas.height = height;

  ctx.clearRect(0, 0, width, height);
  ctx.putImageData(frame, 0, 0);

  return [canvas, width, height];
};
